import { render, staticRenderFns } from "./FloatField.vue?vue&type=template&id=0fc19f88&lang=pug&"
import script from "./FloatField.vue?vue&type=script&lang=js&"
export * from "./FloatField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fc19f88')) {
      api.createRecord('0fc19f88', component.options)
    } else {
      api.reload('0fc19f88', component.options)
    }
    module.hot.accept("./FloatField.vue?vue&type=template&id=0fc19f88&lang=pug&", function () {
      api.rerender('0fc19f88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/fields/FloatField.vue"
export default component.exports